import api from "./api";

export const getServices = async (params = {}) => {
  try {
    const res = await api.get("/services/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};

export const getServiceById = async (id) => {
  try {
    const res = await api.get(`/services/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching service:", error);
    throw error;
  }
};

export const createService = async (data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      title: data.title,
      description: data.description,
      status: data.status || 'draft'
    };
    
    console.log("Sending service data:", formattedData);
    const res = await api.post("/services/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating service:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updateService = async (id, data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      title: data.title,
      description: data.description,
      status: data.status || 'draft'
    };
    
    console.log("Updating service data:", formattedData);
    const res = await api.put(`/services/${id}`, formattedData);
    return res.data;
  } catch (error) {
    console.error("Error updating service:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteService = async (id) => {
  try {
    const res = await api.delete(`/services/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting service:", error);
    throw error;
  }
};

export const uploadServiceImage = async (id, file) => {
  try {
    console.log("=== UPLOADING SERVICE IMAGE ===");
    console.log("Service ID:", id);
    console.log("File:", file.name, file.size, "bytes", file.type);
    
    const formData = new FormData();
    formData.append("image", file);
    
    console.log("Making request to:", `/services/${id}/image`);
    const res = await api.post(`/services/${id}/image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Upload successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING SERVICE IMAGE ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

export const removeServiceImage = async (id) => {
  try {
    console.log("=== REMOVING SERVICE IMAGE ===");
    console.log("Service ID:", id);
    
    // Service'i güncelle ve image'i null yap
    const res = await api.put(`/services/${id}`, {
      image: null
    });
    console.log("Image removal successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR REMOVING SERVICE IMAGE ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};
